import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_CONDOMINIO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolCondominioState extends EntityState<IID_OL_CONDOMINIO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_CONDOMINIO })
@InterfaceDataStore(InterfaceName.CONDOMINIO)
export class IIDolCondominioStore extends EntityStore<IIDolCondominioState> {
  constructor() {
    super([]);
  }
}
